/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import sendImg from 'assets/images/send.jpg'
import { CopyBlock, shadesOfPurple } from 'react-code-blocks'

export const _4 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>4 - Формы</h2>
    <p className={styles.description}>
      <b>Формы</b> - это инструмент HTML для взаимодействия пользователя с сайтом.{' '}
    </p>
    <p className={styles.description}>
      С помощью форм пользователь может вводить какие-либо данные - написать комментарий, выбрать товар и оплатить его с
      помощью кредитной карты, подобрать подходящий маршрут на карте и т.п.{' '}
    </p>
    <p className={styles.description}>
      Все это возможно благодаря тому, что браузер умеет с помощью форм получить данные пользователя и затем
      обрабатывает эти данные сам либо пересылает данные на обработку серверу.{' '}
    </p>
    <p className={styles.description}>
      Изучение обработки данных выходит за рамки нашего курса, т.к. требует знания браузерных языков программирования
      (курс JavaScript) или серверных языков программирования (курсы PHP, Java, Node).{' '}
    </p>
    <p className={styles.description}>
      Когда говорят о веб-формах, подразумевают тег <code className={styles.code}>form</code> и связанные с ним теги -{' '}
      <code className={styles.code}>input</code>, <code className={styles.code}>select</code>,{' '}
      <code className={styles.code}>label</code> и т.д. Название веб-формы они получили из-за того, что тег{' '}
      <code className={styles.code}>form</code> объединяет информацию в группу и подсказывает браузеру, куда эти данные
      отправить (атрибут action) и каким именно способом осуществить отправку (атрибут method).{' '}
    </p>
    <ol className={styles.list}>
      <li className={styles.list__item}>адрес отправки формы (значение свойства action тега form) </li>
      <li className={styles.list__item}>метод отправки формы (значение свойства method тега form) </li>
      <li className={styles.list__item}>элементы ввода (input, textarea, select и т.п.) </li>
      <li className={styles.list__item}>кнопка отправки формы (button или input а атрибутом type="submit") </li>
    </ol>
    <iframe
      height="300"
      scrolling="no"
      title="rotman_html_3_1"
      src="https://codepen.io/rotmanyan/embed/WEXbaQ?default-tab=html%2Cresult&editable=true&theme-id=dark"
      frameBorder="no"
      loading="lazy"
      allowTransparency="true"
      allowFullScreen="true"
    />
    <section className={styles.subsection}>
      <h3 className={styles.h3}>4.1 - Методы передачи данных get и post</h3>
      <p className={styles.description}>
        Браузер имеет несколько методов для отправки запроса - этот механизм встроен в теги{' '}
        <code className={styles.code}>{`<a>`}</code> и <code className={styles.code}>{`<img>`}</code>. Браузер находит
        атрибут <code className={styles.code}>href</code> или <code className={styles.code}>src</code>, получает из них
        строку с <b>url</b>, и обращается по указанному в <b>url</b> протоколу к ресурсу локальному или удаленному
        (через обращение к серверу).{' '}
      </p>
      <p className={styles.description}>
        Похожий, но более мощный механизм встроен в теге <code className={styles.code}>form</code>. Этот механизм не
        использует готовую строку, подобно строке <code className={styles.code}>href</code> или{' '}
        <code className={styles.code}>src</code>, а формирует такую строку сам.{' '}
      </p>
      <p className={styles.description}>
        Вот порядок, в котором происходит создание строки запроса по протоколу <b>HTTP</b>:{' '}
      </p>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          С помощью атрибута <code className={styles.code}>action</code> задается адрес, по которому будет передан
          запрос.{' '}
        </li>
        <li className={styles.list__item}>
          Далее с помощью атрибута <code className={styles.code}>method</code> выбирается один из 2-х вариантов HTTP
          методов - метод <b>GET</b> или <b>POST</b>. Метод <b>GET</b> в браузерах установлен по умолчанию, и его
          специально задавать нет необходимости. Метод <b>POST</b> необходимо задавать, если передаваемые данные
          содержат конфиденциальную информацию - логин и пароль, например.{' '}
        </li>
        <li className={styles.list__item}>
          Затем, после специального знака разделителя, в строке следуют пары{' '}
          <code className={styles.code}>"ключ: значение"</code>.{' '}
        </li>
        <li className={styles.list__item}>
          Атрибут отправки <code className={styles.code}>submit</code> запустит проверку заполнения форм и, в случае
          успеха, закончит формирование строки и передаст ее браузеру.{' '}
        </li>
      </ul>
      <p className={styles.description}>
        Если использовать метод <b>GET</b>, то вся подготовленная строка будет видна в браузере - см. рисунок. Если
        используется метод <b>POST</b>, то видна будет только часть строки - т.н. заголовок. Собственно метод <b>GET</b>{' '}
        и есть отправка заголовка запроса, без подключения тела сообщения, которое осуществляется в методе <b>POST</b>.{' '}
      </p>
      <p className={styles.notificationWarn}>
        При верстке макета в качестве адреса используют <code className={styles.code}>#</code>, т.к. хэш адресует запрос
        на эту же страницу. Т.е. <code className={styles.code}>#</code> используется временно, до работ, связанных с
        подключением сайта с бэкендом или до наполнения его контентом.{' '}
      </p>
      <p className={styles.description}>
        Для знакомства с работой формы создайте файл <b>index.html</b> на своём компьютере и скопируйте в него код формы
        из примера, приведенного ниже. При вводе данных в поле и последующем нажатии на кнопку{' '}
        <code className={styles.code}>"submit"</code> страница перезагрузится и в адресной строке браузера будет
        указано:{' '}
      </p>
      <img className={styles.img} src={sendImg} alt="send" />
      <p className={styles.description}>
        После имени файла появится вопросительный знак, затем будет записано{' '}
        <code className={styles.code}>name=value</code>. Где свойству <code className={styles.code}>name</code>{' '}
        соответствует значение <code className={styles.code}>name</code>, а свойству{' '}
        <code className={styles.code}>value</code> соответствует значение введенное пользователем.{' '}
      </p>
      <p className={styles.description}>
        Если задан атрибут <code className={styles.code}>placeholder</code>, то его значение подсказывает что требуется
        ввести, но при появлении курсора (событие <code className={styles.code}>focus</code>) текст подсказки исчезает.
        Попробуйте ввести другой текст, отличный от слова <code className={styles.code}>value</code> и убедитесь, что в
        строке браузера также происходит изменение. Затем замените значение свойства{' '}
        <code className={styles.code}>name</code> на любое слово - текст строки браузера снова изменится.
      </p>
      <CopyBlock
        text={`<form action="#" method="get">
  <input type="text" name="name" placeholder="value">
  <input type="submit" value="submit">
</form>
`}
        language="html"
        showLineNumbers
        theme={shadesOfPurple}
      />
      <p className={styles.description}>
        Важно внимательно отслеживать заполнение тегов <code className={styles.code}>input</code> атрибутом{' '}
        <code className={styles.code}>name</code>. Пример ниже демонстрирует, что отсутствие этого атрибута затрудняет
        получателю разбор содержимого формы (откройте его в codepen).{' '}
      </p>
      <p className={styles.description}>
        Если форма достаточно большая и не все поля в ней обязательно должны быть заполнены восстановить связь полей и
        их значений, созданных пользователем, становится невозможным.{' '}
      </p>
      <p className={styles.description}>
        Попробуйте в примере ниже заменить <code className={styles.code}>value</code> по умолчанию на произвольные (для
        имени и фамилии). При этом заполните только одно из полей. Станет сложно понять, что является именем, а что
        фамилией.
      </p>
      <iframe
        height="300"
        scrolling="no"
        title="rotman_html_3_1"
        src="https://codepen.io/rotmanyan/embed/zdLVMz?default-tab=html%2Cresult&editable=true&theme-id=dark"
        frameBorder="no"
        loading="lazy"
        allowTransparency="true"
        allowFullScreen="true"
      />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>4.2 - Тег input</h3>
      <p className={styles.description}>Тег input, в зависимости от значения свойства type изменяет форму ввода </p>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Значение type</th>
            <th>Описание</th>
            <th>Тег</th>
            <th>Вид</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>button</td>
            <td>Кнопка</td>
            <td>&lt;input type="button" value = "button"&gt;</td>
            <td>
              <input type="button" value="button" />
            </td>
          </tr>
          <tr>
            <td>checkbox</td>
            <td>
              "Чекбокс" Выбор любых вариантов - от одного до всех (выбор осуществляется только для input с одинаковыми
              значениями свойства <strong>name</strong>)
            </td>
            <td>&lt;input type="checkbox" name="chekbosesGroup"&gt;</td>
            <td>
              <label style={{ color: 'red' }}>
                Red <input type="checkbox" name="checkGroup" value="Red" />
              </label>
              <label style={{ color: 'blue' }}>
                Blue <input type="checkbox" name="checkGroup" value="Blue" />
              </label>
              <label style={{ color: 'green' }}>
                Green <input type="checkbox" name="checkGroup" value="Green" />
              </label>
            </td>
          </tr>
          <tr>
            <td>file</td>
            <td>Выбор файла</td>
            <td>&lt;input type="file"&gt;</td>
            <td>
              <input type="file" />
            </td>
          </tr>
          <tr>
            <td>hidden</td>
            <td>Невидимое поле</td>
            <td>&lt;input type="hidden"&gt;</td>
            <td>
              <input type="hidden" />
            </td>
          </tr>
          <tr>
            <td>image</td>
            <td>Изображение как кнопка</td>
            <td>&lt;input type="image" src = "https://image.ibb.co/gn9Nma/button.png"&gt;</td>
            <td>
              <input type="image" src="https://image.ibb.co/gn9Nma/button.png" alt="button" />
            </td>
          </tr>
          <tr>
            <td>password</td>
            <td>Поле для ввода пароля (вводимые символы отображаются черными кружочками)</td>
            <td>&lt;input type="password" name="pass"&gt;</td>
            <td>
              <input type="password" placeholder="password" />
            </td>
          </tr>
          <tr>
            <td>radio</td>
            <td>
              Выбор только одного из вариантов (выбор осуществляется только для input с одинаковыми значениями свойства{' '}
              <strong>name</strong>)
            </td>
            <td>&lt;input type="radio" name = "radiosGroup"&gt;&lt;input type="radio" name = "radiosGroup"&gt;</td>
            <td>
              <label style={{ color: 'red' }}>
                <input type="radio" name="radioGroup" value="Red" />
                Red
              </label>
              <label style={{ color: 'blue' }}>
                <input type="radio" name="radioGroup" value="Blue" />
                Blue
              </label>
              <label style={{ color: 'green' }}>
                <input type="radio" name="radioGroup" value="Green" />
                Green
              </label>
            </td>
          </tr>
          <tr>
            <td>submit</td>
            <td>Кнопка отправки формы (для написания текста - указать значение свойства value)</td>
            <td>&lt;input type="submit" value = "Submit"&gt;</td>
            <td>
              <input type="submit" value="Submit" />
            </td>
          </tr>
          <tr>
            <td>text</td>
            <td>Простое текстовое поле ввода</td>
            <td>&lt;input type="text" name="anyText"&gt;</td>
            <td>
              <input type="text" placeholder="text" />
            </td>
          </tr>
          <tr>
            <td>color</td>
            <td>Выбор цвета (вызов по клику палитры, предоставляемой ОС)</td>
            <td>&lt;input type="color"&gt;</td>
            <td>
              <label>
                Кликни чтобы <input type="color" />
                выбрать цвет
              </label>
            </td>
          </tr>
          <tr>
            <td>date</td>
            <td>Выбор даты (поддержка в браузере Chrome)</td>
            <td>&lt;input type="date"&gt;</td>
            <td>
              <input type="date" placeholder="date" />
            </td>
          </tr>
          <tr>
            <td>datetime</td>
            <td>Выбор даты и времени (поддержка браузерами запланирована)</td>
            <td>&lt;input type="datetime"&gt;</td>
            <td>
              <input type="datetime" placeholder="datetime" />
            </td>
          </tr>
          <tr>
            <td>datetime-local</td>
            <td>Выбор местного времени (поддержка браузерами запланирована)</td>
            <td>&lt;input type="datetime-local"&gt;</td>
            <td>
              <input type="datetime-local" placeholder="datetime-loca" />
            </td>
          </tr>
          <tr>
            <td>email</td>
            <td>Ввод электронной почты</td>
            <td>&lt;input type="email"&gt;</td>
            <td>
              <input type="email" placeholder="email" />
            </td>
          </tr>
          <tr>
            <td>number</td>
            <td>Ввод числа (можно задать min, max и step)</td>
            <td>&lt;input type="number"&gt;</td>
            <td>
              <label>
                Введите натуральное число от 6 <input type="number" min="6" max="12" step="1" />
                до 12
              </label>
            </td>
          </tr>
          <tr>
            <td>range</td>
            <td>Ввод диапазона (можно задать min, max и step)</td>
            <td>&lt;input type="range"&gt;</td>
            <td>
              <label>
                Введите число от 0.6 <input type="range" min="0.6" max="1.2" step="0.1" />
                до 1.2
              </label>
            </td>
          </tr>
          <tr>
            <td>search</td>
            <td>Поле поиска</td>
            <td>&lt;input type="search"&gt;</td>
            <td>
              <input type="search" placeholder="input keywords" />
            </td>
          </tr>
          <tr>
            <td>tel</td>
            <td>Ввод телефона</td>
            <td>&lt;input type="tel"&gt;</td>
            <td>
              <input type="tel" />
            </td>
          </tr>
          <tr>
            <td>time</td>
            <td>Ввод времени</td>
            <td>&lt;input type="time"&gt;</td>
            <td>
              <input type="time" />
            </td>
          </tr>
          <tr>
            <td>url</td>
            <td>Ввод web-адреса</td>
            <td>&lt;input type="url"&gt;</td>
            <td>
              <input type="url" />
            </td>
          </tr>
          <tr>
            <td>month</td>
            <td>Ввод месяца</td>
            <td>&lt;input type="month"&gt;</td>
            <td>
              <input type="month" />
            </td>
          </tr>
          <tr>
            <td>week</td>
            <td>Ввод недели</td>
            <td>&lt;input type="week"&gt;</td>
            <td>
              <input type="week" />
            </td>
          </tr>
        </tbody>
      </table>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>4.3 - Select</h3>
      <p className={styles.description}>
        Для выбора одного из нескольких вариантов помимо <code className={styles.code}>checkbox</code> используется
        конструкция <code className={styles.code}>select-option</code>. В теге{' '}
        <code className={styles.code}>select</code> задается значение <code className={styles.code}>name</code> и другие
        свойства. Каждый из вариантов для выбора задается в теге <code className={styles.code}>option</code>.{' '}
      </p>
      <iframe
        height="300"
        scrolling="no"
        title="rotman_html_3_1"
        src="https://codepen.io/rotmanyan/embed/NvwwxX?default-tab=html%2Cresult&editable=true&theme-id=dark"
        frameBorder="no"
        loading="lazy"
        allowTransparency="true"
        allowFullScreen="true"
      />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>4.4 - Textarea</h3>
      <p className={styles.description}>
        Для ввода текстовых данных, в которых несколько строчек используется тег textarea.{' '}
      </p>
      <iframe
        height="300"
        scrolling="no"
        title="rotman_html_3_1"
        src="https://codepen.io/rotmanyan/embed/mMqqrR?default-tab=html%2Cresult&editable=true&theme-id=dark"
        frameBorder="no"
        loading="lazy"
        allowTransparency="true"
        allowFullScreen="true"
      />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>4.5 - Placeholder, значение по умолчанию.</h3>
      <p className={styles.description}>
        В некоторых случаях необходимо указать значение по умолчанию. Для этого в тегах{' '}
        <code className={styles.code}>input</code> необходимо указать значение свойства{' '}
        <code className={styles.code}>value</code>, для тега <code className={styles.code}>textarea</code> - поставить
        значение по умолчанию между тегами, для конструкции <code className={styles.code}>select-option</code> - указать
        свойство <code className={styles.code}>selected</code> в соответствующем элементе{' '}
        <code className={styles.code}>option</code>.{' '}
      </p>
      <p className={styles.description}>
        Удобным инструментом является возможность написать подсказку о том, какие данные необходимо вносить в форму.
        Такую подсказку можно реализовать с помощью свойства placeholder. Данное свойство можно указать практически в
        любом элементе формы, где есть текстовый ввод.{' '}
      </p>
      <p className={styles.description}>
        Отличием между <code className={styles.code}>option</code>placeholder и{' '}
        <code className={styles.code}>value</code> c <code className={styles.code}>selected</code> в том, что при
        появлении курсора (событие фокус может быть осуществлено мышью или клавиатурой - кнопкой{' '}
        <code className={styles.code}>tab</code>) текст <code className={styles.code}>placeholder</code> исчезает, а
        текст <code className={styles.code}>value</code> придется удалить. Т.е.{' '}
        <code className={styles.code}>placeholder</code> не является значением{' '}
        <code className={styles.code}>input</code>.{' '}
      </p>
      <iframe
        height="300"
        scrolling="no"
        title="rotman_html_3_1"
        src="https://codepen.io/rotmanyan/embed/jLaaGe?default-tab=html%2Cresult&editable=true&theme-id=dark"
        frameBorder="no"
        loading="lazy"
        allowTransparency="true"
        allowFullScreen="true"
      />
      <p className={styles.description}>
        В заключение рассмотрим пример того, как формы взаимодействуют с сервером. В примере ниже форма предложит
        заполнить адрес, заголовок и тело для электронной почты. С помощью JS формируется строка из элементов формы
        (считывается <code className={styles.code}>name</code> и <code className={styles.code}>value</code>),
        соответствующая готовому почтовому сообщению.
      </p>
      <p className={styles.description}>
        Для отправки с помощью почтового сервера требуется ввести только данные идентификации. Вместо этого JS вызовет
        ваш почтовый клиент по умолчанию (если он не установлен, то ваша ОС предложит установку) и заполнит письмо
        содержимым формы из браузера. Для отправки с помощью вашей учетной записи на почтовом сервере останется нажать
        кнопку "Send".{' '}
      </p>
      <p className={styles.description}>
        Некоторые языки программирования, например PHP, умеют обрабатывать данные форм без предварительного
        преобразования с помощью JS. Именно для PHP очень важно соблюдать все правила заполнения форм, прежде всего,
        следить за атрибутом <code className={styles.code}>name</code>.
      </p>
      <iframe
        height="300"
        scrolling="no"
        title="rotman_html_3_1"
        src="https://codepen.io/rotmanyan/embed/JyajzM?default-tab=html%2Cresult&editable=true&theme-id=dark"
        frameBorder="no"
        loading="lazy"
        allowTransparency="true"
        allowFullScreen="true"
      />
    </section>
  </section>
))
